const ForecastIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" width="28" height="28">
            <g fill="currentColor">
                <path d="M19 11h5l-2.5 3z"></path>
                <circle cx="21.5" cy="16.5" r="1.5"></circle>
                <path fillRule="nonzero" d="M22 11v-6h-1v6z"></path>
                <path d="M14 18h1v3h-1z" id="Path"></path>
                <path d="M14 5h1v6h-1z"></path>
                <path d="M7 19h1v3h-1z"></path>
                <path d="M7 6h1v7h-1z"></path>
                <path fillRule="nonzero" d="M7 13v6h1v-6h-1zm-1-1h3v8h-3v-8zM14 18h1v-7h-1v7zm-1-8h3v9h-3v-9z"></path>
            </g>
        </svg>
    )
}
export default ForecastIcon